import { format } from "date-fns"

export const CHANGED_FIELD_LABELS = {
    actionsHtml: "Actions",
    authorsNotesHtml: "Author's Notes",
    categoryId: "Category",
    classification: "Classification",
    compliance: "Compliance",
    conditionalApplicability: "Conditional",
    frequency: "Frequency",
    heading: "Heading",
    hyperlinksToAdd: "Hyperlinks",
    componentInstructionsHtml: "Component Instructions",
    internalNotes: "Internal Notes (Timing)",
    minutes: "Minutes",
    notesHtml: "Notes",
    relationships: "Relationships",
    scheduleReferences: "Schedule References",
    skillSet: "Skill Set",
    tags: "Tags",
    taskType: "Component Type",
    timing: "Timing",
    unitOfMeasure: "Unit of Measure",
    warnings: "Warnings",
}

export function buildVersionLabel(item) {
    if (item?.entryType === "rollback" && item?.rolledBackToVersion != null) {
        return `Version ${item.version} - Restored from v${item.rolledBackToVersion}`
    }
    if (item?.entryType === "import") {
        return `Version ${item.version} - Import`
    }
    if (item?.entryType === "delete") {
        return `Version ${item.version} - Deleted`
    }
    return `Version ${item?.version ?? "?"}`
}

export function buildCheckpointLabel(item) {
    const checkpointStartedAt = formatDateTime(item?.firstSavedAt ?? item?.createdAt)
    const checkpointUpdatedAt = formatDateTime(item?.createdAt)

    if (!item?.firstSavedAt || item.firstSavedAt === item.createdAt) {
        return `Checkpoint ${checkpointUpdatedAt}`
    }

    return `Checkpoint ${checkpointStartedAt}, last updated ${checkpointUpdatedAt}`
}

export function buildChangedFieldsLabel(changedFields = []) {
    if (!changedFields?.length) return ""

    const visible = changedFields.filter((field) => !field.startsWith("$") && !field.startsWith("_"))
    if (!visible.length) return ""

    return visible.map((field) => CHANGED_FIELD_LABELS[field] ?? field).join(", ")
}

export function formatDateTime(value) {
    if (!value) return "Unknown Date"
    return format(new Date(value), "dd/MM/yyyy HH:mm")
}

export function formatDateTimeInput(value) {
    if (!value) return ""
    return format(new Date(value), "yyyy-MM-dd'T'HH:mm")
}

export function toIsoFromInput(value) {
    if (!value) return ""
    return new Date(value).toISOString()
}

export function findHistoryItemByVersion(history = [], version) {
    const numericVersion = Number(version)
    if (!numericVersion) return null
    return history.find((item) => item.version === numericVersion) ?? null
}

export function findHistoryItemForTime(history = [], asOf) {
    if (!asOf) return null
    const targetTime = new Date(asOf).getTime()
    if (Number.isNaN(targetTime)) return null

    return [...history]
        .filter((item) => new Date(item.createdAt).getTime() <= targetTime)
        .sort((left, right) => right.version - left.version)[0]
}
